import classNames from 'classnames';
import ImageLink from 'components/common/Links/ImageLink/ImageLink';
import { HOME } from 'constants/routes';
import classes from './NavContent.module.css';
import Logo from 'static/logo/logo.svg';

type Props = {
   content?: JSX.Element;
   mobileLeft?: JSX.Element;
   mobileCenter?: JSX.Element;
   mobileRight?: JSX.Element;
};

const NavContent = ({ content, mobileLeft, mobileCenter, mobileRight }: Props) => (
   <>
      <nav className={classes.desktopNavContent}>
         <div className={classes.logo}>
            <ImageLink href={HOME} src={Logo} alt="Logo" />
         </div>
         {content}
      </nav>
      <nav
         className={classNames(
            classes.mobileNavContent,
            { [classes.withoutRight]: mobileLeft && mobileCenter && !mobileRight },
            { [classes.center]: mobileCenter && !mobileLeft && !mobileRight },
         )}
      >
         {mobileLeft && <span className={classes.mobileLeft}>{mobileLeft}</span>}
         {mobileCenter && <span className={classes.mobileCenter}>{mobileCenter}</span>}
         {mobileRight && <span className={classes.mobileRight}>{mobileRight}</span>}
         {content}
      </nav>
   </>
);

export default NavContent;
